// extracted by mini-css-extract-plugin
export default {"subTabPlan1":"SubTabPlan1_subTabPlan1__Boyuv","subTabPlan1Form":"SubTabPlan1_subTabPlan1Form__BUkHg"};